import { useLayoutEffect, useState } from "react";

/**
 * Tablonun gövde yüksekliğini (antd `scroll.y`) ekranda kalan alana göre
 * hesaplar. Sabit `calc(100vh - Npx)` yerine kullanılır; üstteki başlık,
 * kartlar ve araç çubuğu sarılıp uzasa bile tablo kalan tüm alanı doldurur.
 *
 * @param ref      tablonun sarmalayıcı div'ine verilen ref
 * @param reserve  tablo başlığı + altbilgi + alt boşluk için ayrılan piksel
 * @param deps     yeniden ölçüm tetikleyen bağımlılıklar (ör. loading, satır sayısı)
 */
export default function useTableBodyHeight(ref, reserve = 100, deps = []) {
  const [height, setHeight] = useState(360);

  useLayoutEffect(() => {
    const measure = () => {
      const el = ref.current;
      if (!el) return;
      const top = el.getBoundingClientRect().top;
      setHeight(Math.max(180, Math.floor(window.innerHeight - top - reserve)));
    };
    measure();
    window.addEventListener("resize", measure);
    const ro =
      typeof ResizeObserver !== "undefined" ? new ResizeObserver(measure) : null;
    ro?.observe(document.body);
    return () => {
      window.removeEventListener("resize", measure);
      ro?.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return height;
}
